<template>
  <div class="prod-image-cover">
    <img :src="image" alt="" />
  </div>
</template>

<script>
export default {
  props: ["image"],
};
</script>

<style></style>
